import React, { FC, useEffect } from "react";
import OnboardingPatientInfoForm from "@components/Onboarding/OnboardingPatientInfoForm/OnboardingPatientInfoForm";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { useNavigate } from "react-router-dom";
import { useGetPatientQuery } from "@store/patientApi";
import Loader from "@components/Loader/Loader";

const PatientInfo: FC = () => {
  const patientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );
  const accountId = useSelector((state: RootState) => state.account.accountId);
  const navigate = useNavigate();
  const { data: patient, isLoading } = useGetPatientQuery(patientId!, {
    skip: !patientId,
  });

  useEffect(() => {
    if (!accountId) {
      navigate("/onboarding");
    } else if (!patient && !isLoading) {
      navigate("/onboarding/profile");
    }
  }, [patient, navigate, accountId, isLoading]);

  return (
    <>
      {isLoading ? <Loader /> : <OnboardingPatientInfoForm patient={patient} />}
    </>
  );
};

export default PatientInfo;
